import ResourceBlocker from './ResourceBlocker'

export default ResourceBlocker
